/* eslint-disable react/prop-types */
import React from 'react';
import dayjs from 'dayjs';
import { Box, ColumnLayout, Container, Header, SpaceBetween } from '@cloudscape-design/components';
import SentimentLineChart from './sentimentLineChart';
import { Link } from 'react-router-dom';
import { ContactRecord } from '../../../../types/contactRecord';
import { snakeToTitleCase } from '../../../../utils/strings';

export interface ValueWithLabelProps {
  label: string;
  children: React.ReactNode;
}

function ValueWithLabel(props: ValueWithLabelProps) {
  const { label, children } = props;
  return (
    <div>
      <Box variant='awsui-key-label'>{label}</Box>
      <div>{children}</div>
    </div>
  );
}

export interface ContactSummaryProps {
  contactObject: ContactRecord;
}

export default function ContactSummary(props: Readonly<ContactSummaryProps>) {
  const { contactObject } = props;
  return (
    <Container header={<Header headingTagOverride='h3'>Contact Summary</Header>}>
      <ColumnLayout
        columns={3}
        variant='text-grid'
      >
        <SpaceBetween size='xs'>
          <ValueWithLabel label='Contact ID'>{contactObject.contactId}</ValueWithLabel>
          <ValueWithLabel label='Channel'>{snakeToTitleCase(contactObject.channel)}</ValueWithLabel>
          <ValueWithLabel label='Channel Subtype'>{snakeToTitleCase(contactObject.channelSubtype)}</ValueWithLabel>

          <ValueWithLabel label='Initiation method'>{snakeToTitleCase(contactObject.initiationMethod)}</ValueWithLabel>
          <ValueWithLabel label='Disconnected Reason'>{snakeToTitleCase(contactObject.disconnectReason)}</ValueWithLabel>
          {contactObject.previousContactId && (
            <ValueWithLabel label='Previous contact id'>
              <span className='text-info underline'>
                <a
                  rel='noopener noreferrer'
                  href={`/contactSearch/${contactObject.previousContactId}`}
                  target='_blank'
                >
                  {contactObject.previousContactId}
                </a>
              </span>
            </ValueWithLabel>
          )}
          {contactObject.nextContactId && (
            <ValueWithLabel label='Next contact id'>
              <span className='text-info underline'>
                {/* <Link target="_blank" rel="noopener noreferrer" to={`/contact-search/view/${contactObject.nextContactId}`}> */}
                <Link
                  rel='noopener noreferrer'
                  to={`/contact-search/view/${contactObject.nextContactId}`}
                  target='_blank'
                >
                  {contactObject.nextContactId}
                </Link>
              </span>
            </ValueWithLabel>
          )}
          {contactObject.relatedContactId && (
            <ValueWithLabel label='Previous contact id'>
              <span className='text-info underline'>
                <a
                  rel='noopener noreferrer'
                  href={`/contact-search/view/${contactObject.relatedContactId}`}
                  target='_blank'
                >
                  {contactObject.relatedContactId}
                </a>
              </span>
            </ValueWithLabel>
          )}
        </SpaceBetween>
        <SpaceBetween size='xs'>
          <ValueWithLabel label='Connected to system'>{dayjs(contactObject.connectedToSystemTimestamp).format('YYYY-MM-DD HH:mm')}</ValueWithLabel>
          <ValueWithLabel label='Disconnected'>{dayjs(contactObject.disconnectTimestamp).format('YYYY-MM-DD HH:mm')}</ValueWithLabel>
          {contactObject.agentARN && (
            <ValueWithLabel label='Agent'>{`${contactObject.agentFirstName} ${contactObject.agentLastName} (${contactObject.agentUsername})`}</ValueWithLabel>
          )}
          {contactObject.queueName && <ValueWithLabel label='Queue'>{contactObject.queueName}</ValueWithLabel>}
        </SpaceBetween>
        <SpaceBetween size='xs'>
          {contactObject?.conversationCharacteristics?.Sentiment?.SentimentByPeriod && (
            <SentimentLineChart SentimentByPeriod={contactObject.conversationCharacteristics.Sentiment.SentimentByPeriod} />
          )}
        </SpaceBetween>
      </ColumnLayout>
    </Container>
  );
}
